<ng-container *ngIf="allAvailableTreatmentAssingments">
  <div class="row no-gutters mb-5">
    <div class="col-6">
      <a class="specialist-choice-container"
         href="#"
         (click)="selectEmployee(null); false">
        <div class="specialist-choice-image"></div>
        <div class="specialist-choice-description">
          <h2 class="specialist-name text-break px-lg-5"
              [translate]="'BOOKING-PART.STEPS.CHOOSE-SPECIALIST.ANY-SPECIALIST'"></h2>
          <p class="specialist-subtext text-truncate"
             [translate]="'BOOKING-PART.STEPS.CHOOSE-SPECIALIST.BEST-AVAILABILITY'"></p>
        </div>
      </a>
    </div>

    <div *ngFor="let employee of allAvailableTreatmentAssingments.employees"
         class="col-6">
      <div class="specialist-choice-container"
         (click)="selectEmployee(employee); false">
        <div class="specialist-choice-image"
             [style.background-image]="'url(' + employee.photoUrl + '), url(assets/img/placeholder-employee.svg)'">
        </div>
        <div class="specialist-choice-description">
          <h2 class="specialist-name text-break px-lg-5 notranslate">{{ employee.displayName }}</h2>
          <p class="specialist-subtext text-truncate"> &nbsp;
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
